import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import Header from "../../Header/Header";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import { Toaster } from "react-hot-toast";
import { Investor } from "./Investor";
import Reports from "./Reports";
import { createExporters } from "../../../../utils/exportHelpers";
import { formatDate } from "../../../../utils/common";
import { getSetup } from "../../../../utils/apis/masters/masters";
import { Permission } from "../../../../utils/permissions";
library.add(fas);

const investorName = (d) =>
  `${d?.user?.f_name || ""} ${d?.user?.l_name || ""}`.trim();

const bankName = (d) => {
  const bank = d?.bank_account;
  if (!bank) return d?.upi_id || "-";
  return bank.network_id
    ? `${bank.network?.name || ""} ${bank.network?.sub_name || ""}`.trim()
    : `${bank.bank_name || ""} ${bank.firm_name || ""}`.trim();
};

const col = {
  date: { name: "Payment Date", value: (d) => formatDate(d.createdAt) },
  investor: { name: "Investor Name", value: investorName },
  serviceNo: { name: "Service No", value: (d) => d?.user?.contact_no },
  state: { name: "State", value: (d) => d?.user?.users_detail?.state?.name },
  district: { name: "District", value: (d) => d?.user?.users_detail?.city?.name },
  utr: { name: "UTR ID", value: (d) => d?.utr_id },
  amount: { name: "Amount", value: (d) => d?.amount },
};

// Users table: pending payments
const userColumns = [
  col.date,
  col.investor,
  col.serviceNo,
  col.state,
  col.district,
  col.utr,
  col.amount,
];

// Report table: processed payments, with the bank used and the final status
const reportColumns = [
  col.date,
  col.investor,
  col.serviceNo,
  col.state,
  col.district,
  { name: "Bank Name", value: bankName },
  col.utr,
  col.amount,
  { name: "Status", value: (d) => (d?.accepted_rejected ? "Accepted" : "Rejected") },
];

// *****************************************************************************************************

const Tables = () => {


  const { isAllow } = useContext(Context);

  const [status, setStatus] = useState();

  // Users and Report each export exactly the columns shown in their own table
  const userExport = createExporters(userColumns);
  const reportExport = createExporters(reportColumns);


  const [setup, setSetup] = useState({});
  const getsetup = async () => {
    const res = await getSetup();
    await setSetup(res?.data);
  };

  useEffect(() => {
    getsetup();
  }, []);
  const convertrate = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup.deposite_exchange_rate);
    const total = (inr * rate).toFixed(2);
    return total;
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Inward Payment"} link={"/payment/inward-payment"} />
        <section className="AdvanceDashboard">
          {isAllow?.includes(Permission.InwardPayment.InvestorList.name) ? (
            <Investor
              isAllow={isAllow}
              status={status}
              setStatus={setStatus}
              handleExportCSV={userExport.csv}
              handlePrint={userExport.print}
              handleExportExcel={userExport.excel}
              convertrate={convertrate}
            />
          ) : (
            <></>
          )}
          {isAllow?.includes(Permission.InwardPayment.ReportList.name) ? (
            <Reports
              isAllow={isAllow}
              status={status}
              setStatus={setStatus}
              handleExportCSV={reportExport.csv}
              handlePrint={reportExport.print}
              handleExportExcel={reportExport.excel}
              convertrate={convertrate}
            />
          ) : (
            <></>
          )}
        </section>
      </div>

      {/* {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      /> */}
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
